import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	label: string;
	value?: string;
}

const CalendarEventTooltipItem: React.FC<Props> = ({ label, value }) => {
	const { t } = useTranslation();

	if (!value) {
		return <></>;
	}

	return (
		<div className='custom-event__detail__item'>{`${t(label)}: ${value}`}</div>
	);
};

export default CalendarEventTooltipItem;
